<template>
  <div id="wrapper" :class="{ 'has-notification': hasNotification }">
    <!-- eslint-disable vue/no-v-html -->
    <div
      class="top-notification-bar"
      :class="{
        'danger text-white': notificationData['status'] === 'danger',
        'warning': notificationData['status'] === 'warning',
      }"
      v-html="notificationData['msg']"
    ></div>
    <!--eslint-enable-->
    <!-- Business users with RepuAgency premium / new UI entitlement only -->
    <div v-if="user && user.role === 'Business' && usesNewUiChrome" >
      <RepuSideBarNew v-show="!blockedScreen" v-if="isRepuAgency" />
      <SideBarNew v-show="!blockedScreen" v-else />
    </div>
    <!-- Agency users with RepuAgency premium new UI entitlement -->
    <div v-else-if="user && user.role === 'Agency' && user.agency && isAgencySubscribed && usesNewUiChrome" >
      <RepuSideBarNew v-show="!blockedScreen" v-if="isRepuAgency" />
      <SideBarNew v-show="!blockedScreen" v-else />
    </div>
    <!-- All other users (non-subscribed or other roles) with old UI -->
    <div v-else>
      <Topbar v-show="!blockedScreen" :is-menu-opened="showMobileMenu" />
      <RepuSideBar v-show="!blockedScreen" v-if="user && isRepuAgency" />
      <ZenSocialSideBar v-show="!blockedScreen" v-if="user && isZenSocial" />
      <SideBar v-show="!blockedScreen" v-else-if="user && !isRepuAgency" />
    </div>
    
    <div class="content-page" :class="{ 'blocked-screen': blockedScreen, 'subscriber-layout': isSubscriberLayout }">
      <div class="content" style="margin-top:10px;">
        <div class="container-fluid">
          <router-view></router-view>
        </div>
      </div>
    </div>
    <TapEngineCardsAddressModal />
  </div>
</template>

<script>
import Topbar from './Partials/Topbar'
import RepuSideBar from './Partials/RepuAgencySideBar'
import RepuSideBarNew from './Partials/RepuSideBarNew'
import ZenSocialSideBar from './Partials/ZenSocialSideBar'
import SideBar from './Partials/SideBar'
import SideBarNew from './Partials/SideBarNew'
import TapEngineCardsAddressModal from '@components/Agency/TapEngineCardsAddressModal.vue'
import { userUsesNewUiEligible } from '@utils/userUsesNewUiEligible'

export default {
  components: {
    Topbar,
    SideBar,
    ZenSocialSideBar,
    RepuSideBar,
    RepuSideBarNew,
    SideBarNew,
    TapEngineCardsAddressModal,
  },
  metaInfo () {
    let favIcon = 'https://rengine.sfo3.cdn.digitaloceanspaces.com/favicon.png';
    if(window.location.origin.includes('zensocial.io')){
      favIcon = 'https://rengine.sfo3.cdn.digitaloceanspaces.com/zensocial-favicon.ico';
    }else if(this.isReputationHub){
      // ReputationHub uses its own favicon (can be updated when asset is available)
      favIcon = 'https://rengine.sfo3.cdn.digitaloceanspaces.com/repuagency-favicon.png';
    }else if(this.isRepuAgency){
      favIcon = 'https://rengine.sfo3.cdn.digitaloceanspaces.com/repuagency-favicon.png';
    }
    return {
      link: [
        { hid: 'favorite-icon', rel: 'icon', href: this.config && this.config.hasOwnProperty('favicon') ? this.config.favicon ? this.config.favicon : favIcon : '' , type: 'image/x-icon' }
      ]
    }
  },
  data() {
    return {
      showMobileMenu: false,
    }
  },
  computed: {
    config() {
      return this.$store.getters['app/config']
    },
    blockedScreen() {
      return this.$store.getters['auth/blockedScreen']
    },

    user() {
      return this.$store.getters['auth/user']
    },

    usesNewUiChrome() {
      return userUsesNewUiEligible(this.user)
    },

    isAgencySubscribed() {
      return this.$store.getters['auth/isAgencySubscribed']
    },

    isSubscriberLayout() {
      // Check if user should see new UI (subscriber layout)
      if (this.user && this.user.role === 'Business' && this.usesNewUiChrome) {
        return true
      }
      if (this.user && this.user.role === 'Agency' && this.user.agency && this.isAgencySubscribed && this.usesNewUiChrome) {
        return true
      }
      return false
    },

    hasNotification() {
      return this.user && this.user.role === 'Agency' && this.user.agency && this.user.agency.owner.on_trial && this.user.banner_text;
    },

    notificationData() {
      let data = {
        'status': undefined,
        'msg': ''
      }
      if (this.user && this.user.role === 'Agency' && this.user.agency && this.user.agency.owner.on_trial)
      {
        data = {
          'status': 'danger',
          'msg': this.user.banner_text ? this.user.banner_text.replace('$$trial_end_date$$',this.user.agency.owner.trial_end_date).replace('$$trial_days_left$$',this.user.agency.owner.trial_days_left) : ''
        }
      }
      return data
    },
  },
  mounted() {
    if(this.user && this.user.role === 'Agency') {
      this.initFreshdesk();
    }
  },
  methods: {
    initFreshdesk(){
      window.fwSettings={
        'widget_id':73000004278
      };
      if (typeof window.FreshworksWidget !== "function") {
        var n = function () {
          n.q.push(arguments)
        };
        n.q = [];
        window.FreshworksWidget = n
      }
      const script = document.createElement('script');
      script.src = 'https://widget.freshworks.com/widgets/73000004278.js';
      script.async = true;
      script.defer = true;
      document.body.appendChild(script);
    },
    toggleMenu() {
      this.showMobileMenu = !this.showMobileMenu
    },
  },
}
</script>
